/**
 * .tuMetrics {"tu1": 0.96, "tu2": 0.97, "tu3": 1, "notes": "Work card = task|bug; idea stays soft", "tuVersion": "2.5"}
 * .help "Bugs are work items like tasks (boards, VCR, Done). Ideas stay the explore lane."
 */
import type { CardType } from '../types/index.ts';

/** Task and Bug share boards, assignee, timer, sprints. Idea does not. */
export function isWorkCardType(type: CardType | string | null | undefined): boolean {
  return type === 'task' || type === 'bug';
}

export function isIdeaCardType(type: CardType | string | null | undefined): boolean {
  return type === 'idea';
}

/** Lowercase noun for copy ("created a bug"). */
export function cardTypeLabel(type: CardType | string | null | undefined): string {
  if (type === 'bug') return 'bug';
  if (type === 'idea') return 'idea';
  return 'task';
}

/** Title case for UI ("Bug Card"). */
export function cardTypeTitle(type: CardType | string | null | undefined): string {
  if (type === 'bug') return 'Bug';
  if (type === 'idea') return 'Idea';
  return 'Task';
}

/** Feed enum has task_* / idea_* only — bugs reuse task_* events. */
export function feedKindForCardType(type: CardType | string | null | undefined): 'task' | 'idea' {
  return type === 'idea' ? 'idea' : 'task';
}
